export default function Problem() {
  const problems = [
    {
      icon: "ri-phone-line",
      title: "Missed Calls",
      description: `Homeowners call when they're ready to talk. If you're on-site or busy, that enquiry often goes to a competitor who picks up.`,
    },
    {
      icon: "ri-time-line",
      title: "Slow Follow-Up",
      description: `Even when enquiries come through, delays in responding mean homeowners move on. Speed is critical in this market.`,
    },
    {
      icon: "ri-question-line",
      title: "Unclear Next Steps",
      description: `Homeowners want clarity. Without a structured follow-up process, enquiries fall through the cracks and opportunities are lost.`,
    },
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-6xl font-bold text-[#1a2947] mb-6">
            Why Extension Companies <span className="text-[#2B5797]">Lose</span> Enquiries
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-10">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="bg-[#F8FAFC] rounded-2xl p-10 text-center shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-200"
            >
              <div className="w-20 h-20 flex items-center justify-center bg-[#4A6FA5] rounded-full mx-auto mb-6 shadow-md">
                <i className={`${problem.icon} text-4xl text-white`}></i>
              </div>
              <div className="text-3xl font-bold text-[#334155] mb-4">{problem.title}</div>
              <p className="text-lg text-[#334155]/70 leading-relaxed">{problem.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
